// extracted by mini-css-extract-plugin
export var root = "Breadcrumbs-root-WbV9Y";
export var rootArticle = "Breadcrumbs-root-article-vBzxr";
export var rootIcon = "Breadcrumbs-root_icon-ucpay";
export var rootItem = "Breadcrumbs-root_item-kgxDO";
export var rootLink = "Breadcrumbs-root_link-vSrJd";
export var rootSpan = "Breadcrumbs-root_span-3fEWi";